(function () {
  // Existing path: sections that pre-render HTML inside <template data-lazy-content>
  function activateTemplate(el) {
    if (el.dataset.lazyActivated === 'true') return;
    el.dataset.lazyActivated = 'true';

    const template = el.querySelector('template[data-lazy-content]');
    if (!template) return;

    el.appendChild(template.content.cloneNode(true));
    template.remove();
    el.removeAttribute('style');

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(el);
    }

    document.dispatchEvent(new CustomEvent('product-badges:refresh'));
  }

  // New path: sections that store product data as JSON and build cards in JS
  function activateJsonSection(el, attempt) {
    if (el.dataset.lazyActivated === 'true') return;

    // renderLazyProducts is defined by a sibling deferred script. If it hasn't
    // executed yet, retry briefly instead of marking the section activated —
    // otherwise it would be skipped forever with nothing ever rendered.
    if (typeof window.renderLazyProducts !== 'function') {
      attempt = attempt || 0;
      if (attempt < 20) {
        setTimeout(() => activateJsonSection(el, attempt + 1), 100);
      } else {
        console.error('[lazy-section-loader] renderLazyProducts never became available; section will not render', el);
      }
      return;
    }

    el.dataset.lazyActivated = 'true';
    window.renderLazyProducts(el);

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(el);
    }
  }

  function init() {
    const templateSections = document.querySelectorAll('[data-lazy-template]');
    const jsonSections = document.querySelectorAll('[data-lazy-section]');

    if (!templateSections.length && !jsonSections.length) return;

    if (!('IntersectionObserver' in window)) {
      templateSections.forEach(activateTemplate);
      jsonSections.forEach(activateJsonSection);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            if (entry.target.hasAttribute('data-lazy-section')) {
              activateJsonSection(entry.target);
            } else {
              activateTemplate(entry.target);
            }
          }
        });
      },
      { rootMargin: '400px 0px', threshold: 0.01 }
    );

    templateSections.forEach((el) => observer.observe(el));
    jsonSections.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();